import React, {useContext} from 'react'
import classNames from 'classnames'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {toggleMobileMenuAccountMenu} from '../../actions/mobileMenu'
import {logoutToHomepage as logoutAction} from '../../actions/user'
import * as mobileMenu from '../../store/mobileMenu'
import * as user from '../../store/user'
import * as URLS from '../../urls'

import AutoLink from '../AutoLink'
import NoContextLink from '../NoContextLink'
import ZeroHeight from '../ZeroHeight'
import {CartContext} from '../../contexts/CartContext'

const MobileAccountMenu = ({isOpen, logout, toggle, userEmail}) => {
  const {deactivateCart} = useContext(CartContext)

  const handleLogout = () => {
    deactivateCart()
    logout()
  }

  return (
    <section
      className={classNames('mobile-account-menu', {
        'is--open': isOpen,
      })}
    >
      <button className="mobile-account-menu-toggle" onClick={toggle}>
        <div className="mobile-account-menu-toggle-text">{userEmail}</div>
        <svg className="mobile-account-menu-toggle-chevron">
          <use xlinkHref="#icon-nav-chevron" />
        </svg>
      </button>
      <ZeroHeight className="mobile-account-menu-content" isOpen={isOpen}>
        <ul className="mobile-account-menu-links">
          <li>
            <NoContextLink className="mobile-account-menu-link" to={URLS.ACCOUNT_EVENTS}>
              My Events
            </NoContextLink>
          </li>
          <li>
            {/* Technically, we don't know if you have sizes yet, but that's
              okay--fit will redirect you to the correct place */}
            <AutoLink className="mobile-account-menu-link" to={URLS.FIT_SIZES}>
              My Sizes
            </AutoLink>
          </li>
          <li>
            <NoContextLink className="mobile-account-menu-link" to={URLS.ACCOUNT_INFO}>
              Account Info
            </NoContextLink>
          </li>
          <li>
            <button onClick={handleLogout} className="mobile-account-menu-link">
              Logout
            </button>
          </li>
        </ul>
      </ZeroHeight>
    </section>
  )
}

MobileAccountMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  isOpen: mobileMenu.isAccountMenuOpen(state),
  userEmail: user.email(state),
})

const mapDispatchToProps = {
  logout: logoutAction,
  toggle: toggleMobileMenuAccountMenu,
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileAccountMenu)
